export const messages = {
  en: {
    contractApplyDetail: {
      title: 'Contract Information',
      page: {
        title: 'Contract Information',
        subtitle: 'View draft contract profile, rooms and approval flow'
      },
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      contractType: 'Contract Type',
      partyA: 'Party A',
      partyAContact: 'Party A Contact',
      partyAPhone: 'Party A Phone',
      partyB: 'Party B',
      partyBContact: 'Party B Contact',
      partyBPhone: 'Party B Phone',
      operator: 'Operator',
      phone: 'Phone',
      contractAmount: 'Contract Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      signingTime: 'Signing Time',
      relatedFiles: 'Related Files',
      relatedRooms: 'Related Rooms',
      room: 'Room',
      roomCode: 'Room Code',
      builtUpArea: 'Built-up Area',
      squareMeter: 'm²',
      workflowFlow: 'Work Order Flow',
      serialNumber: 'Serial Number',
      processor: 'Processor',
      status: 'Status',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion',
      print: 'Print',
      back: 'Back'
    }
  },
  zh: {
    contractApplyDetail: {
      title: '合同信息',
      page: {
        title: '合同信息',
        subtitle: '查看起草合同档案、关联房屋与审批流'
      },
      contractName: '合同名称',
      contractCode: '合同编号',
      contractType: '合同类型',
      partyA: '甲方',
      partyAContact: '甲方联系人',
      partyAPhone: '甲方联系电话',
      partyB: '乙方',
      partyBContact: '乙方联系人',
      partyBPhone: '乙方联系电话',
      operator: '经办人',
      phone: '联系电话',
      contractAmount: '合同金额',
      startTime: '开始时间',
      endTime: '结束时间',
      signingTime: '签订时间',
      relatedFiles: '相关附件',
      relatedRooms: '关联房屋',
      room: '房屋',
      roomCode: '房屋编号',
      builtUpArea: '建筑面积',
      squareMeter: '平方米',
      workflowFlow: '工单流转',
      serialNumber: '序号',
      processor: '处理人',
      status: '状态',
      processTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见',
      print: '打印',
      back: '返回'
    }
  }
}

